export class vPlayer {
    options: any;
    duration: number;
    position: number =0;
    constructor(vPlayer?) {
        if (vPlayer) {
            this.options = vPlayer.id;
            this.duration = vPlayer.duration;
            this.position = vPlayer.position;
        }
    }
}
